import React from 'react';
import allcash from '../assets/marcas/allcash.webp';
import bailina from '../assets/marcas/bailina.webp';
import creditok from '../assets/marcas/creditok.webp';
import espai from '../assets/marcas/espai.webp';
import hielocity from '../assets/marcas/hielocity.webp';
import idm from '../assets/marcas/idm.webp';
import letrag from '../assets/marcas/letrag.webp';
import maspesos from '../assets/marcas/maspesos.webp';
import nogui from '../assets/marcas/nogui.webp';
import prestimax from '../assets/marcas/prestimax.webp';
import prontocash from '../assets/marcas/prontocash.webp';
import santiagoyfrancisco from '../assets/marcas/santiagoyfrancisco.webp';
import sef from '../assets/marcas/sef.webp';
import solocash from '../assets/marcas/solocash.webp';
import supercash from '../assets/marcas/supercash.webp';
import supermercadolaamistad from '../assets/marcas/supermercadolaamistad.webp';
import unnic from '../assets/marcas/unnic.webp';
import vitalis from '../assets/marcas/vitalis.webp';
import heladitos from '../assets/marcas/heladitos.webp';
import heroeswhisky from '../assets/marcas/heroeswhisky.webp';
import baez_dedomenici from '../assets/marcas/baez_dedomenici.webp';
import capital_diario from '../assets/marcas/capital_diario.webp';
import carola from '../assets/marcas/carola.webp';
import colores from '../assets/marcas/colores.webp';
import credito_diario from '../assets/marcas/credito_diario.webp';
import creditos_presti from '../assets/marcas/creditos_presti.webp';
import CTK from '../assets/marcas/CTK.webp';
import digap from '../assets/marcas/digap.webp';
import DL_realty_group from '../assets/marcas/DL_realty_group.webp';
import dok from '../assets/marcas/dok.webp';
import el_tetu from '../assets/marcas/el_tetu.webp';
import ematech from '../assets/marcas/ematech.webp';
import espacio_sole from '../assets/marcas/espacio_sole.webp';
import fridman from '../assets/marcas/fridman.webp';
import gonnet from '../assets/marcas/gonnet.webp';
import kale from '../assets/marcas/kale.webp';
import nexus from '../assets/marcas/nexus.webp';
import profintech from '../assets/marcas/profintech.webp';
import reach from '../assets/marcas/reach.webp';
import romina_pujol from '../assets/marcas/romina_pujol.webp';
import sunbathe from '../assets/marcas/sunbathe.webp';
import tu_proyecto_ya from '../assets/marcas/tu_proyecto_ya.webp';



import { useTranslation } from 'react-i18next';

const Marcas = () => {
  const [t, i18n] = useTranslation("global");
  const brands1 = [allcash, bailina, creditok, espai, hielocity, idm, vitalis, heladitos,
    heroeswhisky, baez_dedomenici, capital_diario, carola, colores,
    credito_diario, creditos_presti, CTK, digap, DL_realty_group, dok, el_tetu];
  const brands2 = [
    letrag, maspesos, nogui, prestimax, prontocash, santiagoyfrancisco,
    sef, solocash, supercash, supermercadolaamistad, unnic, ematech, espacio_sole, fridman,
    gonnet, kale, nexus, profintech, reach, romina_pujol, sunbathe, tu_proyecto_ya
  ];

  // Duplicamos las marcas para el efecto continuo
  const duplicatedBrands1 = [...brands1, ...brands1, ...brands1];
  const duplicatedBrands2 = [...brands2, ...brands2, ...brands2];

  return (
    <div className='w-full  flex flex-col py-10'>
      <h1 className='text-xl md:text-4xl text-start font-messina tracking-wide text-white mb-2'>
        {t("marcas.title")}
      </h1>
      <div className="h-1 w-20 bg-gradient-to-r from-gray-500 to-transparent mb-10"></div>

      <div className="w-full font-kanit mx-auto text-white overflow-hidden relative h-64 mt-10">
        {/* Primera fila */}
        <div className="absolute top-0 w-full">
          <div
            className="animate-scroll-left-mobile md:animate-scroll-left flex space-x-8"
            style={{ width: `${duplicatedBrands1.length * 5}rem` }} // Ajuste dinámico del ancho
          >
            {duplicatedBrands1.map((brand, index) => (
              <div
                key={`top-${index}`}
                className="flex-shrink-0 w-20 h-20 rounded-full flex items-center justify-center"
              >
                <img src={brand} alt={`brand-${index}`} className="w-full h-full object-contain" />
              </div>
            ))}
          </div>
        </div>

        {/* Segunda fila */}
        <div className="absolute top-32 w-full">
          <div
            className="animate-scroll-right-mobile md:animate-scroll-right flex space-x-8"
            style={{ width: `${duplicatedBrands2.length * 5}rem` }} // Ajuste dinámico del ancho
          >
            {duplicatedBrands2.map((brand, index) => (
              <div
                key={`bottom-${index}`}
                className="flex-shrink-0 w-20 h-20 rounded-full flex items-center justify-center"
              >
                <img src={brand} alt={`brand-${index}`} className="w-full h-full object-contain" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Marcas;